<template>
  <div class="w-full">
    <div class="bg-white shadow-lg rounded-2xl border p-6">
      <!-- Chart -->
      <apexchart
        type="radialBar"
        height="350"
        :options="chartOptions"
        :series="series"
      ></apexchart>

      <p class="text-center">Student Over All performance</p>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: { apexchart: VueApexCharts },
  data() {
    return {
      studentlist:[],
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "50%",
            },
          },
        },
        labels: ["Student"],
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  async created() {
    await this.studentlistget();
  },
  methods: {
    async studentlistget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/users-count-get/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.studentlist = res.data.data;
               const percent = this.studentlist.recent_student_percent || 0;
            this.series = [percent];
          this.chartOptions.plotOptions.radialBar.hollow.size = `${percent}%`;
          }
        });
    },
  },
};
</script>

<style>
.dp__input {
  width: 150px;
  text-align: center;
}
</style>
